'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Backspace = function Backspace(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({
    width: "54",
    height: "44",
    viewBox: "0 0 54 44",
    fill: "none"
  }, props), React__default["default"].createElement("path", {
    d: "M17.9801 1.66549C18.644 0.92385 19.5924 0.5 20.5878 0.5H50C51.933 0.5 53.5 2.067 53.5 4V40C53.5 41.933 51.933 43.5 50 43.5H20.6967C19.6463 43.5 18.6515 43.0283 17.9868 42.215L2.55298 23.3333C1.46198 21.9985 1.50534 20.0681 2.65519 18.7837L17.9801 1.66549Z",
    fill: "none",
    stroke: "#757575"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 16.41L39.59 15L34 20.59L28.41 15L27 16.41L32.59 22L27 27.59L28.41 29L34 23.41L39.59 29L41 27.59L35.41 22L41 16.41Z"
  }));
};

var BackspaceOutlined = iconStyles()(Backspace);

module.exports = BackspaceOutlined;
